import { observer } from 'mobx-react';
import { Avatar, avatarFrom } from '../../../../Avatar';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import { NotTranslated, T } from '../../../../Translations';
import GroupAvatar from '../../../Cutesies/GroupAvatar';
import ParticipantAvatar from '../../../ParticipantAvatar';
import { FilterOption } from './UseParticipantDynamicTypeaheadSelect/Types';

interface Props {
  filterOption: FilterOption;
}

const getAvatar = (filterOption: FilterOption): Avatar =>
  avatarFrom(findLink('avatar', filterOption.links), filterOption.payload.initials);

function FormattedOptionLabel({ filterOption }: Props) {
  return filterOption.payload.type
    .map((type) => {
      switch (type) {
        case 'group':
          return (
            <div className="flex items-center">
              <GroupAvatar />
              <div className="flex flex-col ml-2">
                <p>{filterOption.payload.label}</p>
                {filterOption.payload.participantCount
                  .map((participantCount) => (
                    <p className="font-normal">
                      <T kind="{{count}} Participant" count={participantCount} />
                    </p>
                  ))
                  .getOrElse(emptyFragment)}
              </div>
            </div>
          );
        case 'participant':
          return (
            <div className="flex items-center">
              <div className="w-8 h-8 my-auto">
                <ParticipantAvatar avatar={getAvatar(filterOption)} />
              </div>
              <div className="flex flex-col ml-2">
                <p className="font-normal">{filterOption.payload.label}</p>
                {filterOption.payload.email
                  .map((email) => (
                    <p className="font-normal">
                      <NotTranslated text={email} />
                    </p>
                  ))
                  .getOrElse(emptyFragment)}
              </div>
            </div>
          );
      }
    })
    .getOrElse(emptyFragment);
}

export default observer(FormattedOptionLabel);
